import { render, staticRenderFns } from "./PatientsTable.vue?vue&type=template&id=8c4f5606&scoped=true&"
import script from "./PatientsTable.vue?vue&type=script&lang=js&"
export * from "./PatientsTable.vue?vue&type=script&lang=js&"
import style0 from "./PatientsTable.vue?vue&type=style&index=0&id=8c4f5606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4f5606",
  null
  
)

export default component.exports